import { assembleReplacements, parsedCollection, initCollection } from './helpers';
import replacements from './replacements';

const options = {
    replace: assembleReplacements(replacements),
    addReplacements: assembleReplacements,
};
    
export default options;
export { parsedCollection, initCollection };
